import { css } from '@emotion/css';
import { Color, Font, ScreenBreakpoint, Spacing } from 'src/styles';

export const container = (type: 'warning' | 'error') => css`
  ${Font.lg}
  width: 100%;
  background-color: ${type === 'error' ? Color.Red1 : Color.Orange2};
  min-height: 64px;
`;

export const col = css`
  ${Spacing.p8}
  align-items: center;
  border-top: 1px solid #ccdded;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.35);

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    align-items: flex-start;
  }
`;

export const icon = (type: 'warning' | 'error') => css`
  ${Font.lg}
  ${Spacing.mr4}
  line-height: 0 !important;
  color: ${type === 'error' ? Color.Red7 : Color.Orange6};

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    margin-top: calc((1.562rem - 1.125rem) / 2);
  }
`;
